import styled from 'styled-components'
import { Control as ControlBase } from 'components/form/field/s'

export const Control = styled(ControlBase)`
    transition: margin .2s ease-in-out;

    &.error-within {
        margin-block-end: 40px;
    }
`